import * as React from "react";
import "./categoryContainer.scss";
import {useInView} from "react-intersection-observer";
import createSteps from "../../modules/createSteps";


export default function CategoryContainer ({children,categories,lines=true}) {
    const {ref, entry} = useInView({
        threshold: createSteps(360),
        rootMargin: "-250px 0px 0px 0px",
    });
    let entries;
    if(entry?.rootBounds.width <= 600){
        entries = categories.slice().sort((itemOne,itemTwo) => itemOne.length < itemTwo.length ? -1 : 1)
    }else{
        entries = categories;
    }
    let mapped = entries
    if(lines) {
        mapped = entries.map(item => [item, " | "]).flat();
        mapped.pop();
    }
    return (
        <section ref={ref} className="category-container">
            <h2 className="primary">
                {children}
            </h2>
            <div className="categories">
                {
                    mapped.map((name,i)=> {
                        if(i % 2 === 0 ){
                         // names
                         return <span key={i} className={"category"}>{name}</span>
                        }else{
                            return<span key={i} className={"desktop-only"}>{name}</span>
                        }
                    })
                }
            </div>
        </section>
    )
}